import React from 'react';
import styled from 'styled-components';
import { forDesktop, forIE } from '@westwing/ui-kit/breakPoints';
import Banner from '../Generic/Banner';
import { ReferAFriendData } from '../../redux/homepage/types';
import useGa from '../../hooks/useGa';

interface Props {
    referAFriendData: ReferAFriendData;
}

const StyledBanner = styled.div`
    grid-area: refer-friend;
    margin: 21px 0 0;
    height: 50px;
    overflow: hidden;

    ${forDesktop`
        margin: 10px 0 20px;
        height: 80px;
    `}

    ${forIE`
        -ms-grid-row: 3;
        -ms-grid-column: 1;
        -ms-grid-column-span: 3;
`}
`;
const ReferAFriendBanner: React.FC<Props> = ({ referAFriendData }) => {
    const ga = useGa();

    const hasBanner = !!referAFriendData && (!!referAFriendData.desktopImage || !!referAFriendData.mobileImage);
    return hasBanner ? (
        <StyledBanner>
            <Banner
                shouldLazyLoadBanner
                trackingFn={() => ga.homepage.trackReferAFriendBannerClick(referAFriendData.trackingName || '')}
                trackImpressionFunction={() =>
                    ga.homepage.trackReferAFriendBannerImpression(referAFriendData.trackingName || '')
                }
                mobileImage={referAFriendData.mobileImage}
                desktopImage={referAFriendData.desktopImage}
                targetUrl={referAFriendData.targetUrl}
                altText={referAFriendData.altText}
            />
        </StyledBanner>
    ) : (
        <></>
    );
};

export default ReferAFriendBanner;
